import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { SwiperClass } from 'swiper/react';

import { IProductPageViewModel } from 'Scripts/Types/Litium';

import { getMoveDirection } from 'Utils/getMoveDirection';

import PlayIcon from 'Icons/playicon.svg?react';

import { ISlideModel } from './ProductGalleryContainer';

const ProductSliderPagination = ({
    slides,
    hasVideo,
    translations,
    disabled,
    swiper,
}: {
    slides: ISlideModel[];
    hasVideo: boolean;
    translations: IProductPageViewModel['translations'];
    disabled: boolean;
    swiper: SwiperClass;
}) => {
    const [currentSwipperIndex, setCurrentSwiperIndex] = useState(0);
    const goToSlide = (index: number) => {
        if (swiper.realIndex === index) return;
        const moveDirection = getMoveDirection(
            swiper.realIndex,
            index,
            swiper.slides.length
        );

        if (moveDirection === 'next') {
            swiper.slideNext();
        } else if (moveDirection === 'previous') {
            swiper.slidePrev();
        } else {
            swiper.slideToLoop(index);
        }
    };

    useEffect(() => {
        setCurrentSwiperIndex(swiper?.realIndex);
    }, [swiper?.realIndex]);

    return (
        <motion.ul
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            initial={{ opacity: 0 }}
            className="mt-2 flex justify-center gap-5 md:mt-5"
        >
            {slides.map((dot, index: number) => (
                <li key={index} className="flex">
                    <button
                        data-slide={index}
                        disabled={disabled}
                        onClick={() => goToSlide(index)}
                    >
                        {swiper?.realIndex === index ? (
                            <span className="sr-only">
                                {translations.generalCurrentSlide}
                            </span>
                        ) : (
                            <span className="sr-only">{`${
                                translations.generalGoToSlide
                            } ${index + 1}`}</span>
                        )}
                        <span className="block h-4 w-4 rounded-full border border-black">
                            {dot.videoUrl ? (
                                <span
                                    className={`relative flex h-full w-full items-center justify-center rounded-full ${
                                        swiper?.realIndex === index
                                            ? 'bg-black'
                                            : 'bg-springwood'
                                    } duration-layout`}
                                >
                                    <PlayIcon
                                        className={`absolute ml-[1px] h-2 w-2 ${
                                            swiper?.realIndex === index
                                                ? 'fill-springWood text-springWood'
                                                : 'text-black'
                                        }`}
                                    />
                                </span>
                            ) : (
                                <span
                                    className={`relative block h-full w-full rounded-full bg-black duration-layout ${
                                        currentSwipperIndex === index
                                            ? 'scale-1'
                                            : 'scale-0'
                                    }`}
                                />
                            )}
                        </span>
                    </button>
                </li>
            ))}
        </motion.ul>
    );
};

export default ProductSliderPagination;
